import { Section as BaseSection } from "../components/Section";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import aliceD from "../assets/images/members/Alice_Descamps.png";
import aliceDWebP from "../assets/images/members/Alice_Descamps.webp";
import amelieB from "../assets/images/members/Amelie_Brochu.png";
import amelieBWebP from "../assets/images/members/Amelie_Brochu.webp";
import antoninL from "../assets/images/members/Antonin_Leuret.png";
import antoninLWebP from "../assets/images/members/Antonin_Leuret.webp";
import audreyF from "../assets/images/members/Audrey_Foncelle.png";
import audreyFWebP from "../assets/images/members/Audrey_Foncelle.webp";
import celiaS from "../assets/images/members/Celia_Seba.png";
import celiaSWebP from "../assets/images/members/Celia_Seba.webp";
import chloeS from "../assets/images/members/Chloe_Sharrock.png";
import chloeSWebP from "../assets/images/members/Chloe_Sharrock.webp";
import cibeeK from "../assets/images/members/Cibee_Kamara.png";
import cibeeKWebP from "../assets/images/members/Cibee_Kamara.webp";
import henriC from "../assets/images/members/Henri_Crozel.png";
import henriCWebP from "../assets/images/members/Henri_Crozel.webp";
import margauxO from "../assets/images/members/Margaux_Olivre.png";
import margauxOWebP from "../assets/images/members/Margaux_Olivre.webp";
import matthieuH from "../assets/images/members/Matthieu_Hocquart.png";
import matthieuHWebP from "../assets/images/members/Matthieu_Hocquart.webp";
import noemieM from "../assets/images/members/Noemie_Malaize.png";
import noemieMWebP from "../assets/images/members/Noemie_Malaize.webp";
import sabineC from "../assets/images/members/Sabine_Condiescu.png";
import sabineCWebP from "../assets/images/members/Sabine_Condiescu.webp";
import sophieG from "../assets/images/members/Sophie_Green.png";
import sophieGWebP from "../assets/images/members/Sophie_Green.webp";
import theoR from "../assets/images/members/Theo_Rougier.png";
import theoRWebP from "../assets/images/members/Theo_Rougier.webp";
import * as chunk from "lodash.chunk";
import { Member, WIDTH } from "../components/Member";
import { Slider } from "../components/Slider";
import Tache1 from "../assets/images/Tache1.svg";
import Tache2 from "../assets/images/Tache2.svg";
import Tache3 from "../assets/images/Tache3.svg";
import Tache4 from "../assets/images/Tache4.svg";
import Tache5 from "../assets/images/Tache5.svg";
import { mod } from "../technical/mod";

const Taches = [Tache1, Tache2, Tache3, Tache4, Tache5];

const MEMBERS = [
  {
    portrait: {
      sources: [
        {
          srcSet: aliceDWebP,
          type: "image/webp",
        },
        {
          srcSet: aliceD,
          type: "image/png",
        },
      ],
      img: aliceD,
    },
    name: "Alice",
    job: "Illustratrice",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: amelieBWebP,
          type: "image/webp",
        },
        {
          srcSet: amelieB,
          type: "image/png",
        },
      ],
      img: amelieB,
    },
    name: "Amelie",
    job: "UX designer",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: antoninLWebP,
          type: "image/webp",
        },
        {
          srcSet: antoninL,
          type: "image/png",
        },
      ],
      img: antoninL,
    },
    name: "Antonin",
    job: "Graphiste et motion designer",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: audreyFWebP,
          type: "image/webp",
        },
        {
          srcSet: audreyF,
          type: "image/png",
        },
      ],
      img: audreyF,
    },
    name: "Audrey",
    job: "Chargée de communication",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: celiaSWebP,
          type: "image/webp",
        },
        {
          srcSet: celiaS,
          type: "image/png",
        },
      ],
      img: celiaS,
    },
    name: "Célia",
    job: "Cheffe de projet",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: chloeSWebP,
          type: "image/webp",
        },
        {
          srcSet: chloeS,
          type: "image/png",
        },
      ],
      img: chloeS,
    },
    name: "Chloe",
    job: "Photojournaliste",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: cibeeKWebP,
          type: "image/webp",
        },
        {
          srcSet: cibeeK,
          type: "image/png",
        },
      ],
      img: cibeeK,
    },
    name: "Cibee",
    job: "Dessinatrice et graphiste",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: henriCWebP,
          type: "image/webp",
        },
        {
          srcSet: henriC,
          type: "image/png",
        },
      ],
      img: henriC,
    },
    name: "Henri",
    job: "Développeur web",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: margauxOWebP,
          type: "image/webp",
        },
        {
          srcSet: margauxO,
          type: "image/png",
        },
      ],
      img: margauxO,
    },
    name: "Margaux",
    job: "Graphiste et photographe",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: matthieuHWebP,
          type: "image/webp",
        },
        {
          srcSet: matthieuH,
          type: "image/png",
        },
      ],
      img: matthieuH,
    },
    name: "Matthieu",
    job: "Développeur web",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: noemieMWebP,
          type: "image/webp",
        },
        {
          srcSet: noemieM,
          type: "image/png",
        },
      ],
      img: noemieM,
    },
    name: "Noemie",
    job: "Graphiste et illustratrice",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: sabineCWebP,
          type: "image/webp",
        },
        {
          srcSet: sabineC,
          type: "image/png",
        },
      ],
      img: sabineC,
    },
    name: "Sabine",
    job: "Design",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: sophieGWebP,
          type: "image/webp",
        },
        {
          srcSet: sophieG,
          type: "image/png",
        },
      ],
      img: sophieG,
    },
    name: "Sophie",
    job: "Photographe et vidéaste",
  },
  {
    portrait: {
      sources: [
        {
          srcSet: theoRWebP,
          type: "image/webp",
        },
        {
          srcSet: theoR,
          type: "image/png",
        },
      ],
      img: theoR,
    },
    name: "Theo",
    job: "Chargé de communication",
  },
];

const MEMBER_ITEMS = MEMBERS.map(({ portrait, name, job }, j) => (
  <Member
    portrait={portrait}
    tache={Taches[mod(j, Taches.length)]}
    name={name}
    job={job}
  />
));

function innerDimensions(dom: HTMLElement) {
  const computedStyle = getComputedStyle(dom);

  let width = dom.clientWidth; // width with padding
  let height = dom.clientHeight; // height with padding

  height -=
    parseFloat(computedStyle.paddingTop) +
    parseFloat(computedStyle.paddingBottom);
  width -=
    parseFloat(computedStyle.paddingLeft) +
    parseFloat(computedStyle.paddingRight);

  return { height, width };
}

const Section = styled(BaseSection)`
  background-color: #f1efef;
  position: relative;
  padding-top: 0;
  padding-bottom: 0;

  > div {
    padding-top: 48px;
  }
`;

const PORTRAIT_WIDTH = WIDTH + 48;

export const Lequipe = () => {
  const section = useRef<HTMLDivElement>();
  const [sliderWidth, setWidth] = useState("100%");
  const [chunkedMembers, setChunkedMembers] = useState([]);

  useEffect(() => {
    const domSection = section.current;
    if (!domSection) {
      throw new Error("Section not mounted");
    }

    const portraitCount = Math.floor(
      innerDimensions(domSection).width / PORTRAIT_WIDTH
    );
    setChunkedMembers(chunk(MEMBER_ITEMS, portraitCount));
    setWidth(`${portraitCount * PORTRAIT_WIDTH}px`);
  }, []);

  return (
    <Section ref={section} id="equipe">
      <Slider slides={chunkedMembers} style={{ width: sliderWidth }} />
    </Section>
  );
};
